import React, { PureComponent } from 'react'
import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts'
import { PanelX1 } from '../../Components/Plugin'
import { SCREEN_WIDTH } from '../../Utils/Dimensions'




const DATA = [{
	name: 'Page A',
	pv: 2400,
	amt: 2400
}, {
	name: 'Page B',
	pv: 1398,
	amt: 2210
}, {
	name: 'Page C',
	pv: 9800,
	amt: 2290
}, {
	name: 'Page D',
	pv: 3908,
	amt: 2000
}]


export default class Charts extends PureComponent {

	render() {

		return (
			<>
				<div className="screenCharts">
					<PanelX1 title="نمودار تغییر قیمت روزانه">
						<LineChart
							width={SCREEN_WIDTH - 60}
							height={SCREEN_WIDTH - 60}
							data={DATA}
							margin={{
								top: 0,
								right: 0,
								left: 0,
								bottom: 0
							}}
						>
							<CartesianGrid strokeDasharray="3 3" />
							<XAxis dataKey="name" />
							<YAxis yAxisId="left" />
							<Tooltip />
							<Legend />
							<Line
								yAxisId="left"
								type="monotone"
								dataKey="pv"
								stroke="#8884d8"
								activeDot={{ r: 8 }}
							/>
						</LineChart>
					</PanelX1>
				</div>
			</>
		)

	}

}
